import styled from 'styled-components'
import { Menu, MenuItem } from 'pcln-menu'

const StyledMenu = styled(Menu)``

const StyledMenuItem = styled(MenuItem)`
  font-weight: 400 !important;
`

export { StyledMenu, StyledMenuItem }
